import React, { useCallback } from 'react';
import {
    TrendingUpOutlined,
    SearchOutlined,
    ClockOutlined,
    useBreakpoint,
} from '@landr/maestro';
import {
    SuggestionsType,
    getSuggestionDisplayType,
} from 'components/Filters/context/SearchBarContext/types';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { i18n } from 'utils';

const useSuggestionItem = ({
    applySuggestion,
    deleteUserRecentSearch,
    suggestionType,
    modifiers,
    isHovered,
}: {
    applySuggestion: (modifiers: ModifiersPayload) => void;
    deleteUserRecentSearch: (modifiers: ModifiersPayload[]) => void;
    suggestionType: SuggestionsType;
    modifiers?: ModifiersPayload;
    isHovered: boolean;
}) => {
    const { getFilterLabel, getFilterFamily } = useApiFiltersContext();
    const [params, slug] = modifiers || [undefined, null];

    const handleClick = useCallback(() => {
        !!modifiers && applySuggestion(modifiers);
    }, [modifiers, applySuggestion]);

    const displayableFiltersParams = getSuggestionDisplayType();

    const filterName = slug && getFilterLabel(slug, params);
    const filterParams = params && displayableFiltersParams[params];

    const filterFamily = slug && getFilterFamily(slug);

    const filterCategories = filterFamily ? i18n._(filterFamily) : filterParams;

    const isRecentSuggestion = suggestionType === SuggestionsType.Recent;
    const isMobile = useBreakpoint('md');
    const isRemoveSuggestionVisible =
        isRecentSuggestion && (isMobile || isHovered);

    const handleRemoveRecentSuggestion = useCallback(
        (event: React.MouseEvent) => {
            event.stopPropagation();
            modifiers && deleteUserRecentSearch([modifiers]);
        },
        [deleteUserRecentSearch, modifiers],
    );

    let icon;

    switch (suggestionType) {
        case SuggestionsType.Trending:
            icon = <TrendingUpOutlined size="sm" />;
            break;

        case SuggestionsType.Recent:
            icon = <ClockOutlined size="sm" />;
            break;

        default:
            icon = <SearchOutlined size="sm" />;
            break;
    }

    return {
        filterName,
        filterCategories,
        handleClick,
        icon,
        handleRemoveRecentSuggestion,
        isRemoveSuggestionVisible,
    };
};

export default useSuggestionItem;
